// CSRF token utility for fetch requests
let csrfToken: string | null = null;

export const getCsrfToken = async (): Promise<string | null> => {
  if (csrfToken) {
    return csrfToken;
  }
  
  try {
    const response = await fetch('/api/csrf-token', {
      method: 'GET',
      credentials: 'include'
    });
    
    if (response.ok) {
      const data = await response.json();
      csrfToken = data.csrf_token;
      return csrfToken;
    }
  } catch (error) {
  }
  
  return null;
};

export const clearCsrfToken = (): void => {
  csrfToken = null;
};

export const fetchWithCsrf = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const method = options.method?.toUpperCase();
  
  // Add CSRF token for state-changing requests
  if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method || '')) {
    const csrf = await getCsrfToken();
    if (csrf) {
      options.headers = {
        ...options.headers,
        'X-CSRFToken': csrf
      };
    }
  }
  
  // Ensure credentials are included
  options.credentials = 'include';
  
  return fetch(url, options);
};
